import React from 'react';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function ItemLabel({
  label,
  start,
  end
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [label.slice(0, start), /*#__PURE__*/_jsx("strong", {
      children: label.slice(start, end + 1)
    }), label.slice(end + 1)]
  });
}